import gsap from 'gsap';

// The exit-intent popup's Send button opts out: the magnetic translate drags it
// out of its column and the icon swap is unwanted inside a compact dialog.
const SELECTOR = '.btn--primary:not(.exit-popup__submit)';
const MAGNETIC_STRENGTH = 0.18;
const ICON_TRAVEL = 28;

const prefersReducedMotion = () =>
	window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const bindButton = (btn) => {
	const iconWrap = btn.querySelector('.btn__icon');
	const originalSvg = iconWrap?.querySelector('svg');
	if (!iconWrap || !originalSvg) return null;

	iconWrap.style.position = 'relative';
	iconWrap.style.overflow = 'hidden';

	const ghostSvg = originalSvg.cloneNode(true);
	ghostSvg.setAttribute('aria-hidden', 'true');
	ghostSvg.classList.add('btn__icon-svg--ghost');
	Object.assign(ghostSvg.style, {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		pointerEvents: 'none',
	});
	iconWrap.appendChild(ghostSvg);

	gsap.set(ghostSvg, { xPercent: -150, yPercent: 150, autoAlpha: 0 });

	const moveX = gsap.quickTo(btn, 'x', { duration: 0.5, ease: 'power3.out' });
	const moveY = gsap.quickTo(btn, 'y', { duration: 0.5, ease: 'power3.out' });

	const onPointerMove = (e) => {
		const rect = btn.getBoundingClientRect();
		const relX = (e.clientX - rect.left - rect.width / 2) * MAGNETIC_STRENGTH;
		const relY = (e.clientY - rect.top - rect.height / 2) * MAGNETIC_STRENGTH;
		moveX(relX);
		moveY(relY);
	};

	const onPointerEnter = () => {
		btn.addEventListener('pointermove', onPointerMove);

		const tl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.45 } });
		tl.to(originalSvg, { x: ICON_TRAVEL, y: -ICON_TRAVEL, autoAlpha: 0 }, 0)
			.fromTo(
				ghostSvg,
				{ x: -ICON_TRAVEL, y: ICON_TRAVEL, xPercent: -50, yPercent: -50, autoAlpha: 0 },
				{ x: 0, y: 0, autoAlpha: 1 },
				0.05,
			)
			.to(iconWrap, { scale: 1.08, duration: 0.4, ease: 'back.out(2)' }, 0)
			.to(
				btn,
				{
					boxShadow: '0 14px 32px rgba(0, 113, 189, 0.45)',
					duration: 0.4,
				},
				0,
			);
	};

	const onPointerLeave = () => {
		btn.removeEventListener('pointermove', onPointerMove);
		moveX(0);
		moveY(0);

		const tl = gsap.timeline({
			defaults: { ease: 'power3.out', duration: 0.4 },
			onComplete: () => gsap.set(btn, { clearProps: 'boxShadow' }),
		});
		tl.to(originalSvg, { x: 0, y: 0, autoAlpha: 1 }, 0)
			.to(ghostSvg, { x: -ICON_TRAVEL, y: ICON_TRAVEL, autoAlpha: 0, duration: 0.25 }, 0)
			.to(iconWrap, { scale: 1 }, 0);
	};

	btn.addEventListener('pointerenter', onPointerEnter);
	btn.addEventListener('pointerleave', onPointerLeave);

	return () => {
		btn.removeEventListener('pointerenter', onPointerEnter);
		btn.removeEventListener('pointerleave', onPointerLeave);
		btn.removeEventListener('pointermove', onPointerMove);
	};
};

export const initCtaHoverAnimation = () => {
	if (prefersReducedMotion()) return;
	document.querySelectorAll(SELECTOR).forEach(bindButton);
};
